import { message } from "antd";
import Axios from "axios";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { firebase_app } from "../Config/Config";
import { authHeader, handleResponse } from "../Services/fack.backend";
import { useAPIUser } from "../_helper/User/UserProvider";
const mapStateToProps = ({ dispatch, settings }) => ({
  dispatch,
  settings,
});
const PrivateRoute = (props) => {
  const history = useNavigate();
  const [authenticated, setAuthenticated] = useState(true);
  // const [jwtToken, setJwtToken] = useState(localStorage.getItem('token'));
  const jwtToken = localStorage.getItem("token");
  const { userDetails, setUserDetails } = useAPIUser();
  useEffect(() => {
    Axios.get("apiV1/current-user/", {
      headers: { Authorization: `JWT ${localStorage.getItem("token")}` },
    })
      .then((res) => {
        const { dispatch } = props;
        if (res.status === 200) {
          if (res.data?.organisation?.organisation_id) {
            setUserDetails(res.data);
            localStorage.setItem("currentUser", JSON.stringify(res.data));
            localStorage.setItem("authenticated", true);
            const user = res?.data;
            if (
              user.user_selected_columns == "" ||
              user.user_selected_columns == {} ||
              user.user_selected_columns == []
            ) {
              user.user_selected_columns = {};
            } else {
              user.user_selected_columns = JSON.parse(
                user.user_selected_columns
              );
            }
            user.user_selected_columns = dispatch({
              type: "settings/CHANGE_SETTING",
              payload: {
                setting: "user",
                value: user,
              },
            });
          } else {
            history(`/dashboard`);
            message.error("No associated organisation found!");
            toast.error("No associated oranisation found!");
            localStorage.setItem("authenticated", false);
            localStorage.removeItem("token");
            localStorage.removeItem("userDetails");
          }
        }
      })
      .catch((res) => {
        if (res.status !== 200) {
          // console.log(res.status, "Status4");
          history(`/dashboard`);
          localStorage.setItem("authenticated", false);
        }
      });
    // setJwtToken(localStorage.getItem('token'))
    // setAuthenticated(JSON.parse(localStorage.getItem('authenticated')))
  }, []);
  // console.log(jwtToken, authenticated, currentUser, "Final");
  return authenticated && jwtToken ? (
    <Outlet />
  ) : (
    <Navigate exact to={`/dashboard`} />
  );
};

export default connect(mapStateToProps)(PrivateRoute);
